import { Changes } from "../base/Changes";
import { Entity } from "../base/Entity";
import { Resident } from "../session/impl/Resident";
import { ReplacementClaimState } from "./ReplacementClaimState";

export class ReplacementClaim implements Entity {
  public id: number;
  public changes: Changes;
  public lastStateChangeDate: Date;

  public postalCode: string;
  public houseNumber: number;
  public houseNumberSuffix?: string;
  public streetName?: string;
  public message?: string;
  public resident: Resident;
  public state: ReplacementClaimState;
  public claimStateId: number;
  public claimStateName?: string;
  public retailerIdPreferred?: number;
  public appliances?: {
    description?: string;
    applianceCategory?: string;
    id?: number;
    applianceType?: string;
  }[];
  public applianceCategory?: string;

  public readonly cooldownPeriod: boolean;

  public constructor(replacementClaim: {
    id: number;
    postalCode: string;
    houseNumber: number;
    houseNumberSuffix?: string;
    streetName: string;
    message?: string;
    claimState: ReplacementClaimState;
    resident: {
      id: number;
      firstName: string;
      lastName: string;
      postalCode: string;
      houseNumber: number;
      houseNumberSuffix: string;
      email: string;
      phoneNumber: string;
    };
    appliances?: {
      description?: string;
      applianceCategory?: string;
      id?: number;
      applianceType?: string;
    }[];
    retailerIdPreferred?: number;
    lastStateChangeDate: Date;
    changes: Changes;
  }) {
    this.id = replacementClaim.id;
    this.changes = replacementClaim.changes;
    this.lastStateChangeDate = replacementClaim.lastStateChangeDate;

    this.postalCode = replacementClaim.postalCode;
    this.houseNumber = replacementClaim.houseNumber;
    this.houseNumberSuffix = replacementClaim.houseNumberSuffix;
    this.streetName = replacementClaim.streetName;
    this.message = replacementClaim.message;
    this.resident = new Resident(replacementClaim.resident);

    this.appliances = replacementClaim.appliances;
    if (replacementClaim.appliances && replacementClaim.appliances[0]) {
      this.applianceCategory = replacementClaim.appliances[0].applianceCategory ?? undefined;
    }
    this.state = replacementClaim.claimState;
    this.retailerIdPreferred = replacementClaim.retailerIdPreferred;

    this.claimStateId = this.state.id;
    this.claimStateName = this.state.name;

    this.cooldownPeriod = this.checkCooldownPeriod(this.changes);
  }

  checkCooldownPeriod(changes: Changes): boolean {
    const create = [...changes.fullDetails!.values()].find((item: any) => item.key === "create");
    if (create && create.value) {
      const now = Math.floor(new Date().getTime() / 1000);
      const created = Math.floor(new Date(create.value.time!).getTime() / 1000);
      const ticks = 172800; //48 hours
      if (now - created < ticks) {
        return true;
      }
      return false;
    }

    return false;
  }
}
